// extracted by mini-css-extract-plugin
export default {"Ripple":"Ripple_Ripple__I7gml","ripple":"Ripple_ripple__4De8g"};